// Sign-in, copied from onlycat-admin's OCAuth for the web: Auth0 redirect to
// /account, then the gateway's loginWithAuth0 binds this browser's device
// token to the user. From then on the device token is the API's bearer.
import type { Auth0Client } from "@auth0/auth0-spa-js";
import { disconnectGateway, gatewayRequest } from "./gateway";
import { resetDeviceToken } from "./platform";

const DOMAIN = "auth.onlycat.com";
const CLIENT_ID = "rqwpeo4jPr7QmqR2M4hfvOsL7fRr8FTt";
/** What Auth0 has registered for https://production.onlycat.app (and http://localhost:3000). */
export const redirectUri = () => window.location.origin + "/account";

let client: Promise<Auth0Client> | null = null;
function auth0(): Promise<Auth0Client> {
  client ??= import("@auth0/auth0-spa-js").then(({ Auth0Client }) =>
    new Auth0Client({ domain: DOMAIN, clientId: CLIENT_ID, cacheLocation: "localstorage", authorizationParams: { redirect_uri: redirectUri() } })
  );
  return client;
}

export function isRedirectCallback(url: string): boolean {
  return url.includes("state") && (url.includes("code") || url.includes("error"));
}

/** Where to go after sign-in, remembered across the redirect. */
const RETURN_KEY = "oc.returnTo";

export async function login(returnTo?: string): Promise<void> {
  try { if (returnTo) sessionStorage.setItem(RETURN_KEY, returnTo); } catch { /* ignore */ }
  await (await auth0()).loginWithRedirect({ authorizationParams: { redirect_uri: redirectUri() } });
}

/** On /account: finish the Auth0 redirect, then bind the device token. Returns where to go next. */
export async function handleRedirectCallback(url = window.location.href): Promise<string> {
  const a = await auth0();
  await a.handleRedirectCallback(url);
  const token = await a.getTokenSilently();
  await gatewayRequest("loginWithAuth0", { token });
  let to = "/week";
  try { to = sessionStorage.getItem(RETURN_KEY) || to; sessionStorage.removeItem(RETURN_KEY); } catch { /* ignore */ }
  return to;
}

/** The gateway's "logout" kills the device token; Auth0's session is cleared locally. */
export async function logout(): Promise<void> {
  try { await gatewayRequest("logout", {}); } finally {
    disconnectGateway();
    resetDeviceToken();
    try { await (await auth0()).logout({ openUrl: false }); } catch { /* local cache only */ }
  }
}
